import { AgentConversation } from './AgentConversation';

export function AgentPage() {
  return <div className="content-column agent-page">
    <header className="page-header"><div><p>CAIGEN · AGENT WORKSPACE</p><h1>把信息变成行动</h1><span>长对话、上下文分析与工具确认留在这里；任何页面也可打开右侧轻对话。</span></div><a className="quiet-button" href="/agent/chat.html">进入旧版完整会话</a></header>
    <section className="agent-workspace paper-card">
      <AgentConversation surface="agent-page" spacious />
    </section>
  </div>;
}
